const feedbackList = [
    {
        id: 1,
        name: "Gusto",
        img: "chief.jpg",
        review: "The greatest burger I have ever had in my life.",
        stars: "5"
    },
    {
        id: 2,
        name: "Benjamin",
        img: "foodEater.png",
        review: "I want to have meals from this shop everydays.",
        stars: "4"
    },
    {
        id: 3,
        name: "Thomas",
        img: "tom.png",
        review: "It took me more than 30 minutes to reach this restaurant and the taste gives over the satification. Worth it!",
        stars: "5"
    },
    {
        id: 4,
        name: "Lucy",
        img: "eaterGirl.jpg",
        review: "Burger and fries make my stress run aways. It's a good pleasure by the taste.",
        stars: "4"
    },
    {
        id: 5,
        name: "Leo",
        img: "eaterMan.jpg",
        review: "Food with good quailty, greate taste and fair prices. It's amazing!",
        stars: "5"
    },
    {
        id: 6,
        name: "Chris",
        img: "chris.jpg",
        review: "Food with good quailty, greate taste and fair prices. It's amazing! Food with good quailty, greate taste and fair prices. It's amazing! Food with good quailty, greate taste and fair prices. It's amazing! Food with good quailty, greate taste and fair prices. It's amazing! Food with good quailty, greate taste and fair prices. It's amazing!",
        stars: "5"
    },
];
export default feedbackList;